import React, { useRef } from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import { QRCodeSVG } from "qrcode.react";

function QrLabelModal({ onClose, labelData }) {
  const printRef = useRef();

  if (!labelData) return null;

  const {
    qrValue = "",
    qrText = "",
    isItemUnit = false,
    type = "IN",
    itemText = "",
    qtyText = "",
    partnerName = "",
    dateText = "",
    companyName = "",
  } = labelData;

  // 실제 60mm x 40mm 라벨 프린터 출력 실행
  const handlePrint = () => {
    const qrSvgElement = printRef.current.querySelector("svg");
    const qrSvgHtml = qrSvgElement ? qrSvgElement.outerHTML : "";

    const printWindow = window.open("", "_blank", "width=450,height=380");

    printWindow.document.write(`
      <html>
        <head>
          <title>${qrText}</title>
          <style>
            @page {
              size: 60mm 40mm;
              margin: 0mm;
            }
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
              font-family: 'Malgun Gothic', '맑은 고딕', sans-serif;
              -webkit-print-color-adjust: exact;
            }
            body {
              width: 60mm;
              height: 40mm;
              margin: 0;
              padding: 0;
              overflow: hidden;
            }
            .label-wrap {
              width: 60mm;
              height: 40mm;
              padding: 3mm 2.5mm 2.5mm 2.5mm;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            .label-top {
              display: flex;
              flex: 1;
              align-items: center;
              overflow: hidden;
            }
            .qr-box {
              width: 17mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-right: 2.5mm;
              flex-shrink: 0;
            }
            .qr-box svg {
              width: 15mm !important;
              height: 15mm !important;
            }
            .qr-text {
              margin-top: 1.2mm;
              font-size: 9pt;
              font-weight: 900;
              line-height: 1;
              text-align: center;
              letter-spacing: -0.5px;
              white-space: nowrap;
            }
            .info-box {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 1.4mm;
              overflow: hidden;
            }
            .info-row {
              display: flex;
              align-items: center;
              font-size: 9.5pt;
              font-weight: 900;
              line-height: 1.2;
              white-space: nowrap;
              overflow: hidden;
            }
            .label-title {
              width: 10.5mm;
              display: inline-flex;
              justify-content: space-between;
              flex-shrink: 0;
            }
            .label-colon {
              margin: 0 1mm;
              flex-shrink: 0;
            }
            .label-val {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .company-footer {
              border-top: 1.8px solid #000;
              padding-top: 1.5mm;
              text-align: center;
              font-size: 11pt;
              font-weight: 900;
              letter-spacing: 4px;
              line-height: 1;
            }
          </style>
        </head>
        <body>
          <div class="label-wrap">
            <div class="label-top">
              <div class="qr-box">
                ${qrSvgHtml}
                <div class="qr-text">${qrText}</div>
              </div>
              <div class="info-box">
                <div class="info-row">
                  <span class="label-title"><span>품</span><span>목</span></span>
                  <span class="label-colon">:</span>
                  <span class="label-val">${itemText}</span>
                </div>
                ${
                  isItemUnit
                    ? `<div class="info-row">
                        <span class="label-title"><span>수</span><span>량</span></span>
                        <span class="label-colon">:</span>
                        <span class="label-val">${qtyText}</span>
                      </div>`
                    : ""
                }
                <div class="info-row">
                  <span class="label-title">${
                    type === "IN"
                      ? "<span>입</span><span>고</span><span>처</span>"
                      : "<span>출</span><span>하</span><span>처</span>"
                  }</span>
                  <span class="label-colon">:</span>
                  <span class="label-val">${partnerName || "-"}</span>
                </div>
                <div class="info-row">
                  <span class="label-title">${
                    type === "IN"
                      ? "<span>입</span><span>고</span><span>일</span>"
                      : "<span>출</span><span>하</span><span>일</span>"
                  }</span>
                  <span class="label-colon">:</span>
                  <span class="label-val">${dateText || "-"}</span>
                </div>
              </div>
            </div>
            <div class="company-footer">${companyName}</div>
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() { window.close(); }, 200);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // 항목명 좌우 균등 정렬 스타일
  const titleBoxStyle = {
    width: "50px",
    display: "inline-flex",
    justifyContent: "space-between",
    flexShrink: 0,
  };

  const colonStyle = {
    margin: "0 6px",
    flexShrink: 0,
  };

  const valueStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  // 모든 행 폰트 크기 16.5px로 완전 통일
  const rowStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "16.5px",
    fontWeight: "900",
    lineHeight: "1.2",
    whiteSpace: "nowrap",
    overflow: "hidden",
  };

  return ReactDOM.createPortal(
    <div
      onClick={() => onClose?.()}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "18px",
          padding: "22px 26px 18px 26px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* 화면 미리보기 라벨 영역 */}
        <div
          ref={printRef}
          style={{
            width: "390px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            fontFamily: "'Malgun Gothic', '맑은 고딕', sans-serif",
            color: "#000",
            boxSizing: "border-box",
          }}
        >
          {/* 상단 본문 */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            {/* 좌측 QR 코드 + 번호 */}
            <div
              style={{
                width: "108px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "16px",
                flexShrink: 0,
              }}
            >
              <QRCodeSVG value={String(qrValue)} size={88} level="M" />
              <div
                style={{
                  marginTop: "6px",
                  fontSize: "15px",
                  fontWeight: "900",
                  color: "#000",
                  lineHeight: "1",
                  textAlign: "center",
                  letterSpacing: "-0.5px",
                  whiteSpace: "nowrap",
                }}
              >
                {qrText}
              </div>
            </div>

            {/* 우측 텍스트 영역: 모든 줄 rowStyle(16.5px) 동일 적용, 간격 6px 고정 */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "6px",
                overflow: "hidden",
              }}
            >
              {/* 1. 품목 */}
              <div style={rowStyle}>
                <span style={titleBoxStyle}>
                  <span>품</span>
                  <span>목</span>
                </span>
                <span style={colonStyle}>:</span>
                <span style={valueStyle}>{itemText}</span>
              </div>

              {/* 2. 수량 */}
              {isItemUnit && (
                <div style={rowStyle}>
                  <span style={titleBoxStyle}>
                    <span>수</span>
                    <span>량</span>
                  </span>
                  <span style={colonStyle}>:</span>
                  <span style={valueStyle}>{qtyText}</span>
                </div>
              )}

              {/* 3. 입고처 / 출하처 */}
              <div style={rowStyle}>
                <span style={titleBoxStyle}>
                  {type === "IN" ? (
                    <>
                      <span>입</span>
                      <span>고</span>
                      <span>처</span>
                    </>
                  ) : (
                    <>
                      <span>출</span>
                      <span>하</span>
                      <span>처</span>
                    </>
                  )}
                </span>
                <span style={colonStyle}>:</span>
                <span style={valueStyle}>{partnerName || "-"}</span>
              </div>

              {/* 4. 입고일 / 출하일 */}
              <div style={rowStyle}>
                <span style={titleBoxStyle}>
                  {type === "IN" ? (
                    <>
                      <span>입</span>
                      <span>고</span>
                      <span>일</span>
                    </>
                  ) : (
                    <>
                      <span>출</span>
                      <span>하</span>
                      <span>일</span>
                    </>
                  )}
                </span>
                <span style={colonStyle}>:</span>
                <span style={valueStyle}>{dateText || "-"}</span>
              </div>
            </div>
          </div>

          {/* 하단 회사명 */}
          <div
            style={{
              borderTop: "2px solid #000",
              paddingTop: "10px",
              marginTop: "12px",
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "900",
              letterSpacing: "5px",
              lineHeight: "1",
              color: "#000",
            }}
          >
            {companyName}
          </div>
        </div>

        {/* 모달 하단 닫기 / 인쇄 버튼 */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginTop: "14px",
            gap: "8px",
          }}
        >
          <Button
            onClick={() => onClose?.()}
            sx={{
              fontSize: 14,
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#808080",
              padding: "5px 16px",
              ":hover": { backgroundColor: "#666666" },
            }}
          >
            닫기
          </Button>
          <Button
            onClick={handlePrint}
            sx={{
              fontSize: 14,
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#0067a3",
              padding: "5px 16px",
              ":hover": { backgroundColor: "#004f7c" },
            }}
          >
            인쇄
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default QrLabelModal;